import {motion, useTransform, useScroll} from "framer-motion";
import React, {useRef} from "react";
import {HiArrowRight} from "react-icons/hi2";
import {BsArrow90DegRight} from "react-icons/bs";

const HorizontalScrollCarousel = () => {
    const targetRef = useRef(null);
    const {scrollYProgress} = useScroll({
        target: targetRef,
    });

    const x = useTransform(scrollYProgress, [0, 1], ["7.5%", "-94%"]);

    return (
        <section ref={targetRef} className="relative h-[300vh] ">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <motion.div style={{x}} className="flex gap-4">
                    {cards.map((card) => {
                        return <Card card={card} key={card.id}/>;
                    })}
                </motion.div>
            </div>
        </section>
    );
};

const Card = ({card}) => {
    return (<div
        key={card.id}
        className="group relative h-screen overflow-hidden flex items-center"
    >
        <div className="flex">
            <motion.div
                className="px-4 w-[40rem] py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto"
                variants={{
                    hidden: { opacity: 0, x: -50 },
                    visible: { opacity: 1, x: 0 }
                }}
                initial="hidden"
                whileInView="visible"
                transition={{duration: 0.6, delay: 0.4}}
                viewport={{once: false}}
            >
                <div className="h-full border-2 border-gray-200 border-opacity-60 rounded-lg overflow-hidden">
                    <img className="h-80 w-full object-cover object-center"
                         src={card.imgURL} alt="blog"/>
                    <div className="p-6">
                        <h2 className="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">
                            { card.category }
                        </h2>
                        <h1 className="title-font text-2xl font-bold text-blue-600 mb-3">
                            { card.summary }
                        </h1>
                        <p className="leading-relaxed mb-3 text-base text-gray-600">
                            { card.addition }
                        </p>
                    </div>
                </div>
            </motion.div>
            { card.id!==5 ?
                <motion.div
                    className="text-6xl my-auto ml-20 mr-16"
                    variants={{
                        hidden: { opacity: 0, x: -50 },
                        visible: { opacity: 1, x: 0 }
                    }}
                    initial="hidden"
                    whileInView="visible"
                    transition={{duration: 0.6, delay: 0.8}}
                    viewport={{once: false}}
                >
                    <HiArrowRight />
                </motion.div> :
                <motion.div
                    className="my-auto text-6xl ml-24"
                    variants={{
                        hidden: { opacity: 0, y: -50 },
                        visible: { opacity: 1, y: 0 }
                    }}
                    initial="hidden"
                    whileInView="visible"
                    transition={{duration: 0.6, delay: 0.8}}
                    viewport={{once: false}}
                >
                    <BsArrow90DegRight className="rotate-90" />
                </motion.div> }
        </div>
    </div>);
};

const cards = [
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/impact-1.png",
        category: "Conference",
        summary: "Bielefeld European Meetup",
        addition: "We presented our project poster and learned a lot of synthetic strategies from other iGEM teams around Europe.",
        id: 1
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/impact-2.png",
        category: "Conference",
        summary: "Nordic iGEM conference",
        addition: "We participated in a friendly competition of project presentation, and connected with previous teams and current participants.",
        id: 2
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/impact-3.png",
        category: "Conference",
        summary: "Swedish iGEM Conference",
        addition: "Invited by the Lund iGEM team, we learned about each other’s projects and shared opinions on team management.",
        id: 3
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/impact-4.png",
        category: "Workshop",
        summary: "European Meetup",
        addition: "We heard lectures from Universidad Complutense de Madrid, and exchanged knowledge for projects and other iGEM aspects.",
        id: 4
    },
    {
        imgURL: "https://static.igem.wiki/teams/5122/homepage/impact-5.png",
        category: "Workshop",
        summary: "DTU Biobrick workshop",
        addition: "We participated in lab exercises and received advice from previous iGEM members at Denmark’s Technical University.",
        id: 5,
    }
];

export default function HorizontalScrollImpact() {
    return (
        <HorizontalScrollCarousel/>
    )
}